import { useTranslate } from "@/providers/context";

export const AdminTag = () => {
  const { translate } = useTranslate();
  return (
    <div className="caption-bold w-fit rounded-xl bg-highlightBg px-2 py-1 text-brand-primary">
      {translate("ADMIN")}
    </div>
  );
};
